function detectThankYou() {
    const lp = document.querySelector('[data-js="lp"]'),
        main = document.querySelector('main');

    if(lp) {
        const thankYou = lp.querySelector('.form__thankyou');

        console.log(thankYou);

        setTimeout(function() {
            if(thankYou.classList.contains('.is-hidden')) {
                main.style.top = '0px';
                console.log('aaa');
            }
        }, 1000);
        // else {
        //     main.style.marginTop = '38px';
        // }
    }
}

export default detectThankYou;